export const getIsReferrerSearchListing = (): boolean => {
  // @todo Update to get the URL from a Drupal setting.
  const searchListingUrl = '/find-provider/results';
  return document.referrer.includes(searchListingUrl);
};
